/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createDecorator } from '../../instantiation/common/instantiation.js';
export var IProgressService = createDecorator('progressService');



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/platform/progress/common/progress.js
// module id = 204
// module chunks = 58